import { ModerateSVG } from "./SVGIllustrations";
import { PillSelect } from "@/components/we360/PillSelect";
import { CalculatedBadge } from "@/components/we360/CalculatedBadge";
import { DAY_OPTIONS, TIME_OPTIONS, calculateMET } from "./helpers";

export default function Step3Moderate({ dias, onDiasChange, tiempo, onTiempoChange, errors }) {
  const showTime = dias && dias !== "0";
  const met = calculateMET(4.0, dias, tiempo);
  const isUnsure = tiempo === "unsure";

  return (
    <div>
      <ModerateSVG />
      <div
        className="rounded-[14px] p-3 mt-3 mb-4 text-xs leading-relaxed"
        style={{ background: "#FCFAEE", border: "1px solid #E2D9CB", color: "#2D2A24" }}
      >
        <p className="mb-1">
          Ahora piensa en actividades <strong>moderadas</strong> que te hicieron respirar un
          poco más fuerte de lo normal. Por ejemplo: caminar rápido, bailar, bicicleta suave,
          tareas domésticas pesadas.
        </p>
        <p style={{ color: "#71644C" }}>No incluyas caminar normal — eso va en la siguiente sección.</p>
      </div>

      <PillSelect
        label="Días de actividad moderada (últimos 7 días)"
        options={DAY_OPTIONS}
        value={dias}
        onChange={onDiasChange}
        error={errors?.getError("moderadaDias")}
        testId="f3-mod-dias"
        columns={4}
      />

      {showTime && (
        <PillSelect
          label="Tiempo promedio por día"
          options={TIME_OPTIONS.map((o) => ({ label: o.label, value: o.value }))}
          value={tiempo}
          onChange={onTiempoChange}
          error={errors?.getError("moderadaTiempo")}
          testId="f3-mod-tiempo"
          columns={1}
        />
      )}

      {showTime && tiempo && (
        <CalculatedBadge
          label="MET moderada/semana"
          value={isUnsure ? "—" : met ?? "—"}
          unit={isUnsure ? "" : "MET-min/sem"}
          category={isUnsure ? "No calculable" : null}
          categoryColor={isUnsure ? "#B5A998" : "#F9A01B"}
          testId="badge-met-moderada"
        />
      )}
    </div>
  );
}
